import dayjs from 'dayjs'

import type { TDateArg } from '@/src/general/primitives/dates/date.types'
import { toFirstCharOfDay } from '@/src/general/primitives/dates/dayjs'

import type { TStreakDayLevel, TStreak, TStreakItem } from './streak.type'

type TMapStreakOptions = {
  today: TDateArg
  locale: string
  hasAnimatedToday: boolean
}

export const mapStreak = (days: TStreakItem[], { today, locale, hasAnimatedToday }: TMapStreakOptions): TStreak => {
  const sortedDays = [...days].sort(({ day: a }, { day: b }) => dayjs(a).diff(b, 'minute'))
  const visibleDays = sortedDays.slice(sortedDays.length - 7, sortedDays.length)

  return {
    days: visibleDays.map(({ percentile, day: date }, index, arr) => {
      const isComplete = percentile >= 100
      let level: TStreakDayLevel = 0
      if (isComplete) {
        level = 3
      } else if (percentile > 33 && percentile < 100) {
        level = 2
      } else if (percentile > 0 && percentile <= 33) {
        level = 1
      }

      const isFirstDayOfStreak = index === 0
      const isLastDayOfStreak = index === arr.length - 1
      const isLeftNeighborComplete = !isFirstDayOfStreak
        ? arr[index - 1].percentile >= 100 // aligned with the logic to determine if the current day is level 3, which is >= 100
        : sortedDays.length > visibleDays.length
          ? sortedDays[sortedDays.length - visibleDays.length - 1].percentile >= 100
          : false
      const isRightNeighborComplete = !isLastDayOfStreak ? arr[index + 1].percentile >= 100 : false

      return {
        key: date.toString(),
        date,
        label: toFirstCharOfDay(date, locale).toUpperCase(),
        isToday: date === today,
        level,
        completionRatio: percentile,
        connectLeft: level === 3 && isLeftNeighborComplete,
        connectRight: level === 3 && isRightNeighborComplete,
        shouldAnimateFlame: date === today && level === 3 && !hasAnimatedToday,
      }
    }),
  }
}
